module.exports = __webpack_public_path__ + "media/images/boxes/bip-box180-ba3c7f47d03fbf618b474e0d773a3f06.png";